import SearchIcon from '@mui/icons-material/Search';
import { LoadingButton } from '@mui/lab';
import { useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';

const ButtonSearch = ({ searchData }) => {

    const {t} = useTranslation()
    const matches = useMediaQuery('(min-width:900px)');

    return (
        <LoadingButton
            endIcon={matches && <SearchIcon />}
            // loadingPosition="end"
            variant="contained"
            type="submit"
            onClick={searchData}
            style={{ 
                maxHeight: '36.5px',
            }}
            className='search-btn'
        >
            <div className='text-button'
                style={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }}
            >
                {t('actions.search')}
            </div>
        </LoadingButton>
    )
}

export default ButtonSearch